<script setup lang="ts">
defineProps<{ title: string; subtitle?: string }>()
</script>

<template>
  <section class="fw-surface-card">
    <h1>{{ title }}</h1>
    <p v-if="subtitle">
      {{ subtitle }}
    </p>
    <slot />
  </section>
</template>

<style scoped>
.fw-surface-card {
  background: var(--fw-bg-surface);
  color: var(--fw-text-primary);
  padding: var(--fw-space-md);
  border-radius: 8px;
}
</style>
